export default function WhatIsSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            What Is a Mulebuy Spreadsheet?
          </h2>
          <div className="mt-8 space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            <p>
              The <strong>Mulebuy spreadsheet</strong> is a structured product listing system designed to help shoppers organize items, compare prices, and track purchases efficiently. Unlike traditional online shopping where you browse endless pages, the Mulebuy spreadsheet consolidates thousands of products into a single, easy-to-navigate format.
            </p>
            <p>
              Each <strong>Mulebuy spreadsheet</strong> entry contains detailed product information including item names, pricing data, category tags, and direct links to product pages. This <strong>spreadsheet shopping tool</strong> eliminates the friction of switching between multiple tabs and platforms, making it significantly faster to find what you need.
            </p>
            <p>
              In 2026, the Mulebuy spreadsheet method has gained significant traction among European and Western shoppers who value data-driven purchasing decisions. The <strong>Mulebuy spreadsheet</strong> approach empowers users to view transparent pricing across different categories — from <strong>Shoes</strong> to <strong>Accessories</strong> — all within one organized system.
            </p>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {[
            { step: "1", title: "Browse Listings", desc: "Open the Mulebuy spreadsheet and browse through thousands of categorized product listings." },
            { step: "2", title: "Compare & Select", desc: "Compare prices, check product details, and select the items that match your needs." },
            { step: "3", title: "Purchase via Link", desc: "Click the product link to be redirected to the purchasing platform and complete your order." },
          ].map((item) => (
            <div key={item.step} className="bg-background-100 rounded-lg p-6 md:p-8">
              <span className="font-heading text-4xl font-bold text-primary-500">{item.step}</span>
              <h3 className="mt-4 font-semibold text-foreground-950 text-base">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}